import cn from 'clsx'

import { NavLink, Button } from 'shared-components'

import Marker from '../../images/marker'
import Benmax from '../../images/logos/benmax-blue'
import AmosAir from '../../images/logos/amos-air'
import Bems from '../../images/logos/benmax-maintenance-services'
import HydroIndustries from '../../images/logos/hydro-industries'

import s from './Position.module.sass'

function Position({ position }: any) {
    if (!position) return null

    const { title, description, location, position: posistionType, branch, slug } = position

    const logo = (() => {
        switch (branch?.toLowerCase()) {
            case 'amos-air':
                return AmosAir
            case 'benmax-maintenance-services':
                return Bems
            case 'hydro-industries':
                return HydroIndustries
            default:
                return Benmax
        }
    })()

    return (
        <div className={s.Position}>
            <NavLink href={`/careers/${slug}`}>
                <div className={s.Main}>
                    <div className={cn(s.Type, 'smallCaps')}>{posistionType}</div>
                    <h4>{title}</h4>
                    <div className={cn(s.Copy, 'copy small')}>{description}</div>
                    <div className={cn(s.Location, 'smallCaps')}>
                        {Marker}
                        {location}
                    </div>
                </div>
                <div className={cn(s.Branch, branch && s[branch])}>
                    {logo && logo}
                    {branch === 'benmax-fabrication' && 'Benmax Fabrication'}
                    {branch === 'benmax-service' && 'Benmax Service'}
                </div>
                <Button title="Apply today" small className={s.Button} />
            </NavLink>
        </div>
    )
}

export default Position
